import { CUSTOMER_EXTERNAL_REFERENCE_KEY } from "../constants.js";
export const getCustomerKindleEmail = (customer) => {
    return customer?.externalReferences?.find((ref) => ref.key === CUSTOMER_EXTERNAL_REFERENCE_KEY.KINDLE_EMAIL)?.value;
};
